import { useState } from "react";
import { FiUploadCloud, FiImage } from "react-icons/fi";
import {
  Card,
  CardTitle,
  MediaUpload,
  UploadBox,
  UploadIcon,
  UploadText,
  FileInput,
  Preview,
  PreviewDiv,
  PreviewPlaceholder,
} from "./styles";

export default function Midia({ initialPreview, onFileSelect }) {
  const [previewUrl, setPreviewUrl] = useState(initialPreview || null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const preview = URL.createObjectURL(file);
    setPreviewUrl(preview);

    // ENVIA O ARQUIVO REAL PARA O CriarEvento
    onFileSelect && onFileSelect(file, preview);
  };

  return (
    <Card style={{ gridColumn: "1 / 3" }}>
      <CardTitle>Mídia de cursos</CardTitle>

      <MediaUpload>
        <UploadBox>
          <UploadIcon>
            <FiUploadCloud size={45} />
          </UploadIcon>

          <UploadText>
            Carregar imagem ou vídeo do curso
            <br />
            <span>
              Arraste e solte seu arquivo aqui ou clique para adicionar
            </span>
          </UploadText>

          <FileInput type="file" onChange={handleFileChange} />

          <button>Escolher arquivo</button>

          <small>Suporta: JPG, PNG, MP4, MOV (máx. 10 MB)</small>
        </UploadBox>

        <Preview>
          <h1>Preview</h1>

          <PreviewDiv>
            {previewUrl ? (
              <img
                src={previewUrl}
                alt="Preview"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  borderRadius: "8px",
                }}
              />
            ) : (
              <FiImage size={50} color="#9ca3af" />
            )}
          </PreviewDiv>

          <PreviewPlaceholder>
            {previewUrl ? "Mídia carregada" : "Nenhuma mídia selecionada"}
          </PreviewPlaceholder>
        </Preview>
      </MediaUpload>
    </Card>
  );
}
